import { InjectionToken } from '@angular/core';

export const GTM_MODULE_TOKEN = new InjectionToken<Record<string, string>>('GTM_MODULE_TOKEN');
